import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment-jalaali';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { api } from '../services';


export const Onlinevisit = () => {
  const [fetchedPrice, setFetchedPrice] = useState(null);
  const [formData, setFormData] = useState({
    age: null,
    diabetes: null,
    cornealHump: null,
    rheumatism: null,
    pregnant: null,
    weight: '',
  });
  const visiteBase = process.env.REACT_APP_CRMFILE_SERVER; // e.g. https://visiteonlinedrsalouti.barincloud.ir
  const externalApiKey = process.env.REACT_APP_API_KEY; // apikey from .env
  const [birthDate, setBirthDate] = useState({
    year: '',
    month: '',
    day: '',
  });
  const [calculatedAge, setCalculatedAge] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const navigate = useNavigate();
  const [submitState, setSubmitState] = useState(true);
  const [catDesc, setCatDesc] = useState("");
  const [cat, setCat] = useState("");
  const [searchParams] = useSearchParams();
  const CategoryID = searchParams.get('CategoryID');
  const OID = process.env.REACT_APP_OID || '1';

  // لیست سال‌ها (از ۱۳۰۰ تا ۱۴۰۴)
  const years = Array.from({ length: 1404 - 1300 + 1 }, (_, i) => 1404 - i);

  // لیست ماه‌ها
  const months = [
    { value: 1, label: 'فروردین' },
    { value: 2, label: 'اردیبهشت' },
    { value: 3, label: 'خرداد' },
    { value: 4, label: 'تیر' },
    { value: 5, label: 'مرداد' },
    { value: 6, label: 'شهریور' },
    { value: 7, label: 'مهر' },
    { value: 8, label: 'آبان' },
    { value: 9, label: 'آذر' },
    { value: 10, label: 'دی' },
    { value: 11, label: 'بهمن' },
    { value: 12, label: 'اسفند' },
  ];

  // تابع بررسی سال کبیسه
  const isJalaliLeapYear = (year) => {
    if (!year) return false;
    const mod = year % 33;
    return [1, 5, 9, 13, 17, 22, 26, 30].includes(mod);
  };

  // تنظیم تعداد روزهای ماه
  const getDaysInMonth = (month, year) => {
    if (!month) return [];
    const monthNum = parseInt(month);
    if (monthNum >= 1 && monthNum <= 6) {
      return Array.from({ length: 31 }, (_, i) => i + 1);
    } else if (monthNum >= 7 && monthNum <= 11) {
      return Array.from({ length: 30 }, (_, i) => i + 1);
    } else if (monthNum === 12) {
      return Array.from({ length: isJalaliLeapYear(year) ? 30 : 29 }, (_, i) => i + 1);
    }
    return [];
  };

  // لیست روزها بر اساس ماه و سال
  const days = getDaysInMonth(birthDate.month, birthDate.year);

  // مدیریت تغییرات در select
  const handleDateChange = (event) => {
    const { name, value } = event.target;
    setBirthDate((prev) => {
      const newState = {
        ...prev,
        [name]: value,
      };
      if (name === 'month' || name === 'year') {
        newState.day = '';
      } else if (name === 'day') {
        const validDays = getDaysInMonth(prev.month, prev.year);
        if (!validDays.includes(parseInt(value))) {
          newState.day = '';
        }
      }
      return newState;
    });
  };

  // مدیریت تغییرات فرم
  const handleFromChange = (event) => {
    const { name, value } = event.target;
    if (name === 'cornealHump') {
      if (value === '') {
        navigate('/');
        return;
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // بررسی خطاها و به‌روزرسانی submitState
  useEffect(() => {
    const { cornealHump } = formData;
    const hasErrors = cornealHump !== '1';
    setSubmitState(hasErrors);
  }, [formData]);

  // محاسبه سن با moment-jalaali
  const calculateAge = (jalaliDate) => {
    try {
      const birthMoment = moment(jalaliDate, 'jYYYY/jMM/jDD');
      const currentMoment = moment();
      const age = currentMoment.diff(birthMoment, 'years');
      console.log('Calculated age:', age);
      return age >= 0 ? age : null;
    } catch (error) {
      console.error('Error calculating age:', error);
      return null;
    }
  };

  // محاسبه سن هنگام تغییر تاریخ
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await api.get(`home/ShowDoctorCategory?OID=${OID}`);
        let data = response.data;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (error) {
            console.error('Invalid JSON string:', data);
            return;
          }
        }
        // مرتب‌سازی بر اساس SortOrder
        const sortedData = data.sort((a, b) => a.SortOrder - b.SortOrder);
        // فیلتر کردن بر اساس CategoryId
        const filteredData = sortedData.filter(
          (category) => category.ServiceCategoryID === parseInt(CategoryID)
        );
        setCatDesc(filteredData[0].Description);
        setCat(filteredData[0]);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();

    const { year, month, day } = birthDate;
    if (year && month && day) {
      const jalaliDate = `${year}/${month.padStart(2, '0')}/${day.padStart(2, '0')}`;
      console.log('jalaliDate:', jalaliDate);
      const age = calculateAge(jalaliDate);
      setCalculatedAge(age);
      setFormData((prevData) => ({
        ...prevData,
        age: age,
      }));
    } else {
      setCalculatedAge(null);
      setFormData((prevData) => ({
        ...prevData,
        age: null,
      }));
    }
  }, [birthDate, CategoryID]);

  useEffect(() => {
    // fetch price (GetTarefe) from external service if env variables present
    const fetchTarefe = async () => {
      if (!visiteBase || !externalApiKey) {
        console.warn('[Onlinevisit] VISITE URL or API_KEY not set in env');
        return;
      }
      try {
        const base = visiteBase.replace(/\/$/, '');
        const url = `${base}/api/DoAPI?APIKEY=${encodeURIComponent(externalApiKey)}&func=GetTarefe`;
        const res = await fetch(url);
        const text = await res.text();
        let data;
        try {
          data = JSON.parse(text);
        } catch {
          data = text;
        }
        console.log('[Onlinevisit] GetTarefe response:', data);
        // try common shapes to extract price
        let priceVal = null;
        if (data == null) priceVal = null;
        else if (typeof data === 'number') priceVal = data;
        else if (Array.isArray(data) && data.length > 0) {
          priceVal = data[0]?.Price || data[0]?.price || data[0]?.TariffPrice || data[0]?.Amount || null;
        } else if (typeof data === 'object') {
          priceVal = data.Price || data.price || data.TariffPrice || data.Amount || null;
        }
        if (priceVal != null) {
          const num = Number(priceVal);
          if (!Number.isNaN(num)) setFetchedPrice(num);
        }
      } catch (err) {
        console.error('[Onlinevisit] fetch GetTarefe error:', err);
      }
    };

    fetchTarefe();
  }, [visiteBase, externalApiKey]);

  const handelSubmidt = () => {
    if (!submitState) {
      // build appointmentData object and save to localStorage
      const nowDate = moment().format('YYYY/MM/DD');
      const nowTime = moment().format('HH:mm');

      const appointmentDataObj = {
        dateSelected: nowDate,
        timeSelected: nowTime,
        num: -1,
        // priority: fetchedPrice from external API -> cat.Price -> fallback constant
        price: fetchedPrice ?? cat?.Price ?? 2797000,
        doctorName: '',
        doctorFamil: '',
        serviceCategoryId: cat?.ServiceCategoryID ? Number(cat.ServiceCategoryID) : (CategoryID ? Number(CategoryID) : 48),
        serviceCategoryName: cat?.ServiceCategoryName || '',
        doctorId: -1,
        serviceDoctorId: -1,
        createdAt: new Date().toISOString(),
      };

      try {
        localStorage.setItem('appointmentData', JSON.stringify(appointmentDataObj));
        // also set the legacy/individual keys used elsewhere
        localStorage.setItem('date_n', appointmentDataObj.dateSelected);
        localStorage.setItem('time', appointmentDataObj.timeSelected);
        localStorage.setItem('ServiceCategoryID', String(appointmentDataObj.serviceCategoryId));
        localStorage.setItem('ServiceCategoryName', appointmentDataObj.serviceCategoryName);
        console.log('[Onlinevisit] appointmentData saved:', appointmentDataObj);
      } catch (e) {
        console.error('[Onlinevisit] Failed to save appointmentData to localStorage', e);
      }

      navigate(`/Paymentvo?OID=${OID}&CategoryID=${appointmentDataObj.serviceCategoryId}&CategoryName=${encodeURIComponent(appointmentDataObj.serviceCategoryName)}`);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalMessage('');
  };

  return (
    <>
      <section className="container mb-5 mt-xl-0 mt-4">
        <div className="row mb-4 mt-2">
          <div className="col-lg-12 path">
            <ul>
              <li>
                <Link className="text-decoration-none" to="/">
                  صفحه اصلی
                </Link>
                <FontAwesomeIcon icon={faAngleLeft} className="mr-2" />
              </li>
              <li>
                <span>  مشاوره غیر حضوری</span>
              </li>
            </ul>
          </div>
        </div>
        <br />

        <div className="card p-3 shadow rounded-3">
          <h5 className="text-right">
           {catDesc}
          </h5>
        </div>

        <div className="justify-content-center mt-2 p-0">
          <div className="row d-flex align-items-stretch">
            <div className="col-lg-6 h-100">
              <div className="card-body card p-3 shadow rounded-3 p-4 text-center h-100" style={{ overflow: 'visible' }}>
                <form className="d-flex flex-column" style={{ minHeight: '100%' }}>
                   
<div className="form-group form-check " style={{ fontFamily: 'IRANSans', fontSize: '12px' }}>
    <label className="form-check-label mt-2">
      <span className="warning-animation" style={{ color: 'red' }}>شرایط و قوانین</span>
    <br />
    <hr />
    <div style={{ textAlign: 'justify' , fontSize: '12px' , fontFamily: 'IRANSans' , direction: 'rtl' , justifyContent:'end' }}>
      <p>1. مشاوره درباره عمل حذف عینک یا بیماری قوز قرنیه می باشد..</p>
      <p>2.	 پاسخ مشاوره از طریق سایت قابل دسترسی است و علاوه بر آن طی تماس تلفنی اطلاع داده می شود. </p>
      <p>3. زمان انتظار جهت پاسخگویی مشاوره سه روز کاری است.</p>
      <p>4. هزینه مشاوره غیر حضوری مبلغ {fetchedPrice} ریال و غیر قابل استرداد است.</p>

    </div>
  </label>

  <RadioGroup
    row
    className="custom-radio-group"
    aria-labelledby="demo-row-radio-buttons-group-label"
    name="cornealHump"
    value={formData.cornealHump}
    onChange={handleFromChange}
    
  >
    <FormControlLabel value="1" control={<Radio />} label="تایید می نمایم!" />
  </RadioGroup>
</div>

                  <button
                    onClick={handelSubmidt}
                    
                    className="btn btn-primary btn-nobat mt-auto "
                    disabled={submitState}
                    style={{
                      backgroundColor: '#0db2ba',
                      width: 'auto',
                      margin: '0 auto',
                      display: 'block',
                      padding: '13px 40px',
                      fontSize: '14px',
                      borderRadius: '4px',
                      border: 'none',
                      boxShadow: 'none'
                    }}
                  >
                    ارسال
                  </button>
                  <p>&nbsp;</p>
   <p>&nbsp;</p>
   <p>&nbsp;</p>
      <p>&nbsp;</p>
         <p>&nbsp;</p>
                </form>
              </div>
            </div>
            <div className="col-lg-6 m-auto h-100">
              <div className="card-body card p-3 shadow rounded-3 p-4 text-center h-100" style={{height: '630px', overflow: 'visible' }}>
                <img
                  src="/online-medical.png"
                  style={{ maxHeight: '630x'}}
                  className="img-fluid p-2 d-lg-block d-none"
                  alt="Online Medical"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal show={showModal} onHide={handleCloseModal} centered dir="rtl">
        <Modal.Header closeButton className="w-100">
          <Modal.Title className="text-right w-100">خطا</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-right">{modalMessage}</p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button variant="primary" onClick={handleCloseModal}>
            بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Onlinevisit;




